module.exports = __webpack_public_path__ + "static/media/Armaldo_gaussian2.84f2c44c.png";